import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  AccountClaimFileImportMonitoringSummary,
  AccountClaimsMonitoring,
  AccountClaimsMonitoringDetail,
  ClaimFilesInspectSummary,
  ClaimsTimeseries,
} from '@rivethealth/data/account';
import { map } from 'rxjs';
import { AdminCellApiTranslator } from './cell';
import { API_URL } from './common';

@Injectable({ providedIn: 'root' })
export class ClaimsMonitoringService {
  constructor(
    @Inject(API_URL) private readonly apiUrl: string,
    private readonly http: HttpClient,
    private readonly adminCellApiTranslator: AdminCellApiTranslator,
  ) {}

  getAll = (useServiceDate: boolean) =>
    this.adminCellApiTranslator
      .getAll<AccountClaimsMonitoring[]>(
        `${this.apiUrl}/accounts/claims-monitoring`,
        {
          useServiceDate: useServiceDate.toString(),
        },
      )
      .pipe(
        map(results =>
          results.flatMap(result =>
            result.response.map(r => ({ ...r, cell: result.cell })),
          ),
        ),
      );

  getByAccountId = (accountId: number, useServiceDate: boolean) =>
    this.http.get<AccountClaimsMonitoringDetail>(
      `${this.apiUrl}/accounts/claims-monitoring/${accountId}`,
      {
        params: {
          useServiceDate: useServiceDate.toString(),
        },
      },
    );

  getCountByAccountId = (
    accountId: number,
    useServiceDate: boolean,
    range?: string,
  ) =>
    this.http.get<ClaimsTimeseries>(
      `${this.apiUrl}/accounts/claims-monitoring/count/${accountId}`,
      {
        params: range
          ? {
              useServiceDate: useServiceDate.toString(),
              range,
            }
          : { useServiceDate: useServiceDate.toString() },
      },
    );

  getClaimFileImportMonitoring = (accountId: number) =>
    this.http.get<AccountClaimFileImportMonitoringSummary>(
      `${this.apiUrl}/accounts/claims-monitoring/files/${accountId}`,
    );

  getClaimFilesInspectSummary = (accountId: number, fileName: string) =>
    this.http.get<{ claimFilesInspectSummary: ClaimFilesInspectSummary }>(
      `${this.apiUrl}/accounts/claims-monitoring/files-inspect/${accountId}`,
      {
        params: { fileName: fileName.toString() },
      },
    );
}
